<template>
  <div class="ly_cont_main_wrapper">
    <div v-if="showContMain" class="ly_cont_main">
      <div class="ly_cont_main_img">
        <img src="/img/clock.png" />
      </div>
      <!-- /.ly_cont_main_img -->
      <div class="ly_cont_main_txt">
        <div class="bl_cont_main">
          <div class="bl_cont_main_txt">
            <span v-html="$t('paypayPaymentOrderProcessing')"></span>
          </div>
          <!-- /.bl_cont_main_txt -->
          <div class="bl_cont_sub_txt">
            <p v-html="$t('paypayPaymentOrderPurchaseContinueOrCancel')"></p>
          </div>
        </div>
        <!-- /.bl_cont_main -->
      </div>
      <!-- /.ly_cont_main_txt -->
    </div>
    <!-- /.ly_cont_main -->
  </div>
  <!-- /.ly_cont_main_wrapper -->
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class CoinPurchasePendingPayPay extends Vue {
  @Prop({ default: true })
  showContMain!: boolean
}
</script>

<style scoped>
.ly_cont {
  position: relative;
  height: auto;
  min-height: 100%;
}

.ly_cont_main_wrapper {
  font-family: sans-serif;
  font-size: 14px;
  color: #262626;
}

.ly_cont_main_img {
  padding-top: 8px;
  text-align: center;
  object-fit: contain;
}

.ly_cont_main_txt {
  font-weight: 600;
  padding-top: 32px;
}

.bl_cont_sub_txt {
  padding-top: 24px;
  padding-bottom: 24px;
  font-size: 14px;
  font-weight: 600;
  color: #0f0f0f;
}

.bl_cont_main {
  text-align: center;
}

.bl_cont_main_txt {
  font-size: 20px;
}
</style>
